<template>
<div id="nearby_page">
    <div class="main-wrap" v-on:scroll.passive="scollPos($event)">
        <div class="nearby-wrap">
            <div class="nearby-menu">
                <!-- <a href="#" @click="showMap">지도보기</a> -->
                <a href="javascript:void(0);" @click="showComponent" v-if="show_type == 'list'">
                    <span class="btn-showmap btn-nearby"><img src="../../assets/images/map.png" />지도보기</span>
                </a>
                <a href="javascript:void(0);" @click="showComponent" v-if="show_type == 'map'">
                    <span class="btn-showmap btn-nearby"><img src="../../assets/images/list.png" />목록보기</span>
                </a>
                <div>
                    <select @change="distanceChange" v-model="sel_distance" class="select-length">
                        <option :key="index" v-for="(item, index) in distances" :value="item">{{ item }}Km</option>
                    </select>
                    <div class="btn-refresh" @click="myLocationRefresh"><img src="../../assets/images/Refresh.png" alt="refresh" /></div>
                </div>
            </div>
            <vertical-list-component v-if="show_type == 'list'" ref="vertical" />
            <map-component v-if="show_type == 'map'" ref="map" :map_type="'list'" :distance="sel_distance" />
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';
import EventBus from '../../js/event_bus';

import VerticalListComponent from '../component/VerticalListComponent';
import MapComponent from '../component/MapComponent';
import CompanyInfoComponent from '../component/CompanyInfoComponent';

export default {
    name: 'nearby_page',
    components: {
        'vertical-list-component': VerticalListComponent,
        'map-component': MapComponent,
        'company-component': CompanyInfoComponent,
    },
    data() {
        return {
            kakao_key: config.KAKAO_MAP_KEY,
            container: {},
            options: {},
            my_lat: '',
            my_lon: '',
            // store_list: [],
            list_type: 'nearby',
            distances: [2, 5, 10],
            sel_distance: 10,
            show_type: 'list',
            params: {},
            scrollY: ''
        }
    },
    created() {
        EventBus.$on('set_params_nearby', (data) => {
            data.scrollY = this.scrollY; // 스크롤 데이터            
            common.setParams(data);
            EventBus.$emit('detail-data', data);
            this.$router.push('/detail');
        });
    },
    mounted() {
        this.$nextTick(function () {
            var getParams = common.getParams();
            var l_page = this.$store.getters['getLastPage'];
            if (l_page.value == "/detail") {
                setTimeout(function () {
                    var el_chk = document.getElementById('elem_' + getParams.elem_index);
                    if (el_chk != null) {
                        document.getElementById('elem_' + getParams.elem_index).scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }, 500);
            }
            if (getParams != null && getParams != 'undefined') {
                if (Object.keys(getParams).length !== 0) {
                    this.params = getParams;
                    this.sel_distance = this.params.distance;
                    this.initApp();
                } else {
                    this.sel_distance = 10;
                    this.params.keyword = '';
                    this.initApp();
                }
            }

            EventBus.$on('nearby-search-data', (data) => {
                this.params = data;
                this.initApp();
            });

        });
    },
    methods: {
        initApp() {
            common.setLocationData((data) => {
                if (typeof this.params.keyword != 'undefined' && this.params.keyword != '') {
                    data.type = config.REQ_SEARCH_STORE_LIST;
                    data.search_type = 'nearby';
                    data.distance = this.sel_distance;
                } else {
                    data.type = config.REQ_NEARBY_STORE_LIST;
                }
                data.distance = this.sel_distance;
                data.keyword = this.params.keyword;
                if (this.show_type == 'list') {
                    this.$refs.vertical.initComponent(data);
                } else if (this.show_type == 'map') {
                    this.$refs.map.initComponent(data);
                }

            });
        },
        scollPos(e) {
            this.scrollY = e.target.scrollTop;
        },
        distanceChange() {
            this.initApp();
        },
        showComponent() {
            if (this.show_type == 'list') {
                this.show_type = 'map'
            } else if (this.show_type == 'map') {
                this.show_type = 'list'
            }
            this.initApp();
        },
        myLocationRefresh() {
            this.initApp();
        },
    },
    beforeDestroy() {
        // 이벤트버스 사용 후 해제 시켜줄 것 그렇지 않으면 객체가 쌓이는 현상이 발생
        EventBus.$off('nearby-search-data');
        EventBus.$off('set_params_nearby');
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/NearbyPage.vue